import { action, observable } from 'mobx';

import { RootStore } from 'stores/rootStore';
import { API_ACCOUNT_FINANCE_OVERVIEW, API_ACCOUNT_FINANCE_RENT } from 'api/endpoints';
import { PersonType } from 'enums';
import { ReservesData } from 'stores/workflowStores/finances/newReservesStore/model';
import { YearAndMonth } from 'common/interfaces';
import { DepositsData } from 'stores/workflowStores/finances/depositsStore/model';
import { RentData } from 'stores/workflowStores/finances/rent/model';
import { TargetsData } from 'stores/workflowStores/finances/targets/model';
import { ExternalProductsData } from 'pages/Accounts/Edit/components/ExternalProducts/model';

export const rentTabs = [
  'finQuestionnary_forWhoPlan',
  'finQuestionnary_aboutFamily_tabName',
  'finQuestionnary_insurance',
  'finQuestionnary_countInRetirement',
  'finQuestionnary_rent_tabName',
];

export interface OverviewData {
  personType: PersonType;
  rentData: RentData;
  reserveData: ReservesData;
  targetData: TargetsData;
  depositData: DepositsData;
  externalProductData: ExternalProductsData;
  retired: boolean;
  age: YearAndMonth;
  calculatedRetirementAge: YearAndMonth;
  plannedRetirementAge: YearAndMonth;
  options: { defaultInflationRate: number; defaultInflationType: string; };
}

export class FinancesStore {
  rootStore: RootStore;
  accountId: string;
  @observable data: OverviewData | null = null;

  constructor(rootStore: RootStore, accountId: string) {
    this.rootStore = rootStore;
    this.accountId = accountId;
  }

  @action
  fetchData = async () => {
    this.rootStore.stores.uiStore.setLoading(true);
    const response = await this.rootStore.stores.apiStore.get<OverviewData>(
      API_ACCOUNT_FINANCE_OVERVIEW(this.accountId),
    );
    if (response?.data) {
      this.data = response.data
    }
    this.rootStore.stores.uiStore.setLoading(false);
  };

  deleteRent = async () => {
    this.rootStore.stores.uiStore.setLoading(true);
    await this.rootStore.stores.apiStore.delete(API_ACCOUNT_FINANCE_RENT(this.accountId));
    await this.fetchData();
    this.rootStore.stores.uiStore.setLoading(false);
  };

  @observable isRentOpen = false;

  @action setIsRentOpen = (isRentOpen: boolean) => {
    return (this.isRentOpen = isRentOpen);
  };

}
